import * as constants from '../constants/constants';
import { DEFAULT_MENU_DAYS_COUNT, getDefaultMenu } from '../constants/appConstants';

const defaultStore = {
  menus: '',
  filteredMenu: false,
  sameDaysCount: '0',
  selectedDayCount: DEFAULT_MENU_DAYS_COUNT,
  chosenEatings: [],
  complexMenuId: '',
  isMenuLoading: false,
  isShowConfirmPublishComplex: false,
  // menu block properties
  menu: getDefaultMenu(),
  // template container properties
  menuAllTemplates: [],
  menuTemplate: null,
  menuTemplatesPageCount: 0,
  menuTemplatesCurrentPage: 1,
  menuSearchNameTemplate: '',
  menuIsLoadTemplates: false,
  menuErrMessTemplates: '',
  isChangeTheSameDays: true,
  unwantedFood: [],
  unwantedFoodDay: [],
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case 'GET_USER_MENUS_SUCCESS':
      return {
        ...state,
        menus: action.data,
      };

    case constants.SET_MENU_LOADING:
      return {
        ...state,
        isMenuLoading: action.data,
      };

    case 'FILTER_MENU_SUCCESS':
      return {
        ...state,
        filteredMenu: action.data,
      };

    case 'FILTER_MENU_ERROR':
      return {
        ...state,
        filteredMenu: [],
      };

    case 'SHOW_ALL_MENUS':
      return {
        ...state,
        filteredMenu: false,
      };

    case 'CLEAR_ALL_MENUS':
      return {
        ...state,
        menus: false,
        filteredMenu: false,
      };

    case 'SET_SAME_DAYS_COUNT':
      return {
        ...state,
        sameDaysCount: action.data,
      };

    case 'SET_DAYS_COUNT':
      return {
        ...state,
        selectedDayCount: action.data,
      };

    case 'SET_COMPLEX_MENU_ID':
      return {
        ...state,
        complexMenuId: action.data,
      };
    case constants.TOGGLE_LOAD_MENU_GENERATOR_TEMPLATES:
      return {
        ...state,
        menuIsLoadTemplates: !state.menuIsLoadTemplates,
      };
    case constants.GET_MENU_GENERATOR_TEMPLATES_SUCCESS:
      return {
        ...state,
        menuAllTemplates: action.payload.data.menus,
        menuTemplatesPageCount: action.payload.data.pages,
        menuIsLoadTemplates: false,
        menuErrMessTemplates: '',
      };
    case constants.GET_MENU_GENERATOR_TEMPLATES_ERROR:
      return {
        ...state,
        menuAllTemplates: [],
        menuTemplatesPageCount: 0,
        menuErrMessTemplates: action.payload.message,
      };
    case constants.SET_SEARCH_MENU_GENERATOR_TEMPLATE_NAME:
      return {
        ...state,
        menuSearchNameTemplate: action.payload.name,
      };
    case constants.SET_MENU_GENERATOR_TEMPLATES_PAGINATION_PAGE:
      return {
        ...state,
        menuTemplatesCurrentPage: action.payload.numberPage,
      };
    case constants.SET_MENU_GENERATOR_TEMPLATE:
      return {
        ...state,
        menuTemplate: action.payload.template,
      };
    case constants.TOGGLE_IS_SHOW_CONFIRM_PUBLISH_COMPLEX:
      return {
        ...state,
        isShowConfirmPublishComplex: !state.isShowConfirmPublishComplex,
      };
    case constants.SET_CHOSEN_EATINGS: {
      return {
        ...state,
        chosenEatings: action.payload.chosenEatings,
      };
    }
    case constants.SET_MENU_MENU_GENERATOR:
      return {
        ...state,
        menu: action.payload.menu,
      };
    case constants.TOGGLE_CHANGE_THE_SAME_DAYS:
      return {
        ...state,
        isChangeTheSameDays: !state.isChangeTheSameDays,
      };
    case constants.SET_UNWANTED_FOOD:
      return {
        ...state,
        unwantedFood: action.payload.unwantedFood,
      };
    case constants.SET_UNWANTED_FOOD_DAY:
      return {
        ...state,
        unwantedFoodDay: action.payload.unwantedFoodDay,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/menu.js